import React, { useState, useCallback } from 'react'
import t from '~t'

import { Button, Icon } from '~ui'
import OpenAllBookmarks from '~co/bookmarks/openAll'

export default function BookmarksSelectModeOpen({ selectMode = {} }) {
    const [show, setShow] = useState(false)
    const { spaceId, all, ids = [] } = selectMode

    const onOpenSelectedClick = useCallback(() => setShow(true), [])
    const onOpenSelectedClose = useCallback(() => setShow(false), [])

    return (
        <Button
            variant='outline'
            title={t.s('open')}
            disabled={!all && !ids.length}
            onClick={onOpenSelectedClick}>
            <Icon name='open' />

            <span className='hide-on-small-body'>
                {t.s('open')}
            </span>

            {show ? (
                <OpenAllBookmarks
                    spaceId={spaceId}
                    selected={true}
                    onClose={onOpenSelectedClose} />
            ) : null}
        </Button>
    )
}
